import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'cs-exercise-button-bar',
  templateUrl: 'cs-exercise-button-bar.html',
  host: { 'class': 'exercise-button-bar' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsExerciseButtonBarComponent {
  protected LL = LL;

  @Output() instructionsClick = new EventEmitter<Event>();
  @Output() historyClick = new EventEmitter<Event>();
  @Output() addNoteClick = new EventEmitter<Event>();
  /** show the "Add Note" button; the page hides it once the exercise has a pinned note */
  @Input() showAddNote = false;

  onInstructionsClick(event: Event) {
    this.instructionsClick.emit(event);
  }

  onHistoryClick(event: Event) {
    this.historyClick.emit(event);
  }

  onAddNoteClick(event: Event) {
    this.addNoteClick.emit(event);
  }
}
